export default __webpack_public_path__ + "static/media/source.8bc51010.svg";